import { render, staticRenderFns } from "./SalesforceConfigCard.vue?vue&type=template&id=66c8a854&"
import script from "./SalesforceConfigCard.vue?vue&type=script&lang=ts&"
export * from "./SalesforceConfigCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports